import { useEffect, useState } from "react";

// Breakpoint único para toda la app — por debajo de esto la UI pasa de
// 3 columnas fijas (nav + lista + lectura) a una pila de pantallas al
// estilo apps de mail móviles (nav en drawer, lista o lectura a pantalla
// completa, nunca dos paneles lado a lado).
const MOBILE_QUERY = "(max-width: 768px)";

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = () => setIsMobile(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
